import {
	getCandidatePrimaryProfile,
	postJobSearch,
	getJobTypes,
	getLocations,
	getSalaryRange,
	getPublicAssessments,
	getTopCompanies,
	toggleBookmark,
	withdrawApplication,
	getProfileSkills,
	getCuratedJobs,
	getGlobalTrending,
	getJobPreference,
} from "@/utils/apiFunctions";
import { watch } from "vue";
import { mapGetters } from "vuex";
import { trackJobViewed } from "../../utils/posthogHelpers"
import { Capacitor } from "@capacitor/core";
import { Geolocation } from "@capacitor/geolocation";
import PaymentComingSoonModal from "@/views/MyProfile/PaymentComingSoonModal.vue";
import EventBus from "@/utils/EventBus";
import itemTrackingMixin from "@/tracking/mixins/itemTrackingMixin";

const TEMP_FILTERS = {
	sortBy: "relevance_-1",
	dateOfPosting: null,
	experience: [],
	workType: [],
	jobType: [],
	minSalary: null,
	maxSalary: null,
	customerID: [],
	industry: [],
	qualifications: [],
	noticePeriod: null,
	companyType: null,
	locationsArray: [],
};

export default {
	mixins: [itemTrackingMixin],
	beforeCreate() {
		//Logic to add constants to computed properties
		let constants = this.$options.constants;
		let computeds = {};
		if (constants) {
			Object.keys(constants).forEach(function (constantKey) {
				computeds[constantKey] = function () {
					return Object.freeze(constants[constantKey]);
				};
			});
			this.$options.computed = {
				...this.$options.computed,
				...computeds,
			};
		}
	},
	constants: {
		//Anything declared here will be added to the computed properties
		SORT_BY_TAB: "sortBy",
		POSTED_DATE: "dateOfPosting",
		EXPERIENCE: "experience",
		WORK_TYPE: "workType",
		JOB_TYPE: "jobType",
		MIN_SALARY: "minSalary",
		MAX_SALARY: "maxSalary",
		CUSTOMER_ID: "customerID",
		INDUSTRY: "industry",
		EDUCATION: "qualifications",
		NOTICE_PERIOD: "noticePeriod",
		COMPANY_TYPE: "companyType",
		LOCATIONS: "locationsArray",

		FILTER_TABS: {
			sortBy: {
				text: "Sort By",
				options: {
					"relevance_-1": "Most Recommended",
					"createdAt_-1": "Most Recent",
					"salary_-1": "Salary (Hight to Low)",
					"distance_-1": "Distance (Near to Far)",
				},
			},
			dateOfPosting: {
				text: "Posted Date",
				options: {
					0: "Anytime",
					1: "Past 24 Hours",
					2: "Past Week",
					3: "Past Month",
				},
			},
			experience: {
				text: "Experience Level",
				options: {
					"0-2": "Fresher (0-2 years)",
					"2-4": "Junior (2-4 years)",
					"4-6": "Senior (4-6 years)",
					"6-8": "Lead (6-8 years)",
					"8-12": "Management (8-12 years)",
					"12+": "Others",
				},
				isMulti: true,
			},
			// workType: {
			//   text: "Work Type",
			//   options: {
			//     Hybrid: "Hybrid",
			//     Remote: "Remote",
			//     "From Office": "From Office"
			//   },
			//   isMulti: true
			// },
			jobType: {
				text: "Job Type",
				// options: {
				// 	contract: "Contract",
				// 	freelancer: "Freelance",
				// 	"full time": "Full Time",
				// 	"temporary resource": "Temporary Resource",
				// 	government: "Government Jobs",
				// },
				isDynamic: true,
				isMulti: true,
			},
			minSalary: {
				text: "Salary",
				isDynamic: true,
				// options: {
				// 	5: "More than 5 Lakhs",
				// 	10: "More than 10 Lakhs",
				// 	15: "More than 15 Lakhs",
				// 	20: "More than 20 Lakhs",
				// 	25: "More than 25 Lakhs",
				// 	30: "More than 30 Lakhs",
				// },
			},
			customerID: {
				text: "Top Companies",
				isDynamic: true,
				isMulti: true,
			},
			// industry: {
			//   text: "Industry",
			//   options: {
			//     "Real State": "Real State",
			//     "Hospitals and Health Care": "Hospitals and Health Care",
			//     "Primary and Secondary Education": "Primary and Secondary Education",
			//     "Legislative Offices": "Legislative Offices",
			//     "Political Organization": "Political Organization",
			//     "Information Services": "Information Services",
			//     "Software Development": "Software Development"
			//   },
			//   isMulti: true
			// },
			qualifications: {
				text: "Education",
				options: {
					"10th": "10th",
					"12th": "12th",
					ug: "Graduation/Diploma",
					pg: "Masters/Post-Graduation",
					phd: "Doctorate/PhD",
				},
				isMulti: true,
			},
			noticePeriod: {
				text: "Notice Period",
				options: {
					"7days": "7 days",
					"15days": "15 days",
					"30days": "30 days",
					"2months": "60 days",
					"3months": "90 days",
					immediate: "Immediate",
					"currently on notice period": "Currently on Notice Period",
				},
			},
			// companyType: {
			//   text: "Company Type",
			//   options: {
			//     Corporate: " Corporate",
			//     "Foreign MNC": "foreign MNC",
			//     "Indian MNC": "Indian MNC",
			//     MNC: "MNC",
			//     Government: "Government",
			//     Others: "Others"
			//   },
			//   isMulti: true
			// },
			locationsArray: {
				text: "Location",
				isMulti: true,
				isDynamic: true,
			},
		},

		MOBILE_SCREENS: {
			MAIN_SCREEN: "main-screen",
			JOB_DETAILS: "job-details",
			RESUME_SCREEN: "resume-screen",
			SAVED_JOBS: "saved-jobs",
			APPLY_JOB: "apply-job",
			TEST_DETAILS: "test-details",
		},
	},
	beforeDestroy() {
		EventBus.$off("login-success", this.createdActions);
		EventBus.$off("job-preference-updated", this.onJobPreferenceUpdated);
		EventBus.$off("onboarding-fetch-post-login", this.createdActions);
	},
	created() {
		EventBus.$on("login-success", this.createdActions);
		EventBus.$on("job-preference-updated", this.onJobPreferenceUpdated);
		EventBus.$on("onboarding-fetch-post-login", this.createdActions);
		this.createdActions();
	},
	data() {
		return {
			showPreferences: false,
			logout: false,
			dynamicFilters: {
				customerID: [],
				locationsArray: [],
				minSalary: [],
				jobType: [],
			},
			mockInterviewTaken: null,
			showPaymentComingSoonModal: false,
			location: {
				latitude: null,
				longitude: null,
			},

			currentMobileScreen: null,
			currentTab: this.$route?.query?.tab || "hire",
			relatedJobs: null,
			relatedAssessments: null,
			bookmarkedJobs: null,
			jobs: null,
			candidateData: null,
			selectedJob: null,
			jobToMatch: null,
			showWithdrawApplicationModal: false,
			showCannotWithdrawApplicationModal: false,
			showCompleteProfileModal: false,
			showSidePanel: false,
			showTestDetails: false,
			selectedAssessment: null,
			loader: false,
			buttonLoader: false,
			govtJobModal: false,

			currentFilterTab: "sortBy",

			showApplyJob: false,
			showFilter: false,
			showBookmarked: false,
			prefDefaultLocation: "",
			prefLoader: false,

			tempFilters: { ...TEMP_FILTERS },

			filters: {
				sortBy: {
					column: "relevance",
					order: "-1",
				},
				dateOfPosting: null,
				experience: [],
				workType: [],
				jobType: [],
				minSalary: null,
				maxSalary: null,
				customerID: [],
				industry: [],
				qualifications: [],
				noticePeriod: null,
				companyType: null,
				locationsArray: [],
			},

			tempSearchQuery: "",
			tempLocations: "",
			searchQuery: "",
			bookmarkedSearchQuery: "",
			locations: "",
			search: "",
			page: 0,
			count: 20,
			total: null,
			loader: false,
			pageEnd: null,
			loadingMore: false,
		};
	},
	components: {
		PaymentComingSoonModal,
	},
	watch: {
		$route: {
			handler(to) {
				if (to.name === "JobSearch") {
					if (!to.query.tab) {
						this.$router.replace({
							query: {
								...to.query,
								tab: this.currentTab || "hire",
							},
						});
					} else if (to.query.tab !== this.currentTab) {
						this.currentTab = to.query.tab;
					}
				}
				if (to.query.searchQuery) {
					this.search = to.query.searchQuery;
					this.searchQuery = to.query.searchQuery;
					this.tempSearchQuery = to.query.searchQuery;
					this.showBookmarked = false;
					this.page = 0;
					this.getJobs(this.$options.name === "MobileJobSearch", false);
					return; // Exit early to prevent filters watcher from also firing
				}
			},
			immediate: true,
		},
	},
	methods: {
		onJobPreferenceUpdated() {
			this.getPreferences(true);
		},
		hasAccess() {
			return hasAccess();
		},
		openLoginModal() {
			EventBus.$emit("open-login-modal");
		},
		async createdActions() {
			if (this.$route.query.searchQuery) {
				this.searchQuery = this.$route.query.searchQuery;
				this.tempSearchQuery = this.$route.query.searchQuery;
			}
			if (this.$route.query.locations) {
				this.locations = this.$route.query.locations;
				this.tempLocations = this.$route.query.locations;
			}
			await this.getPreferences();
			if (this.$route.query.screen) {
				this.currentMobileScreen = this.$route.query.screen;
			} else {
				this.currentMobileScreen = this.MOBILE_SCREENS.MAIN_SCREEN;
			}

			this.showBookmarked = this.getBoolean(this.$route.query.bookmarked);
			this.getLatLong();
			if (this.showBookmarked) {
				this.showBookmarkedJobs();
			} else {
				if (this.$route.query.screen) {
					this.currentMobileScreen = this.$route.query.screen;
				} else {
					this.currentMobileScreen = this.MOBILE_SCREENS.MAIN_SCREEN;
				}
			}
			if (this.currentTab === "curated") {
				this.currentFilterTab = "minSalary";
				this.getCuratedJobs();
			} else {
				this.currentFilterTab = "sortBy";
				this.getJobs();
			}
			this.getCandidatePrimaryProfile();
			this.getTopCompanies();
			this.getLocations();
			this.getSalaryRange();
			this.getJobTypes();
		},
		switchTab(tab) {
			if (this.currentTab !== tab) {
				let newQuery = { ...this.$route.query, tab: tab };
				delete newQuery.searchQuery;
				delete newQuery.locations;

				this.$router.replace({
					query: newQuery,
				});

				this.currentTab = tab;
				this.searchQuery = "";
				this.tempSearchQuery = "";
				this.locations = "";
				this.tempLocations = "";

				this.resetFilterWithoutApply();
				this.page = 0;
				this.jobs = null;

				if (tab === "curated") {
					this.currentFilterTab = "minSalary";
					this.getCuratedJobs();
				} else {
					this.currentFilterTab = "sortBy";
					this.getJobs(this.$options.name === "MobileJobSearch");
				}

				if (this.$options.name === "MobileJobSearch") {
					this.currentMobileScreen = this.MOBILE_SCREENS.MAIN_SCREEN;
					this.scrollToTop();
				}
			}
		},
		async getJobs(isMobile = false, allBookmarked = false) {
			this.loader = true;
			// this.isManualClear = false;
			try {
				let res = null;
				let payload;
				if (allBookmarked) {
					payload = {
						bookmarked: this.showBookmarked ? true : null,
						searchQuery: this.bookmarkedSearchQuery,
						jobID: this.$route.query.jobID ? this.$route.query.jobID : "",
						page: this.page,
						count: this.count,
					};
				} else {
					let minSalaryValue = null;
					let maxSalaryValue = null;
					if (
						this.filters.minSalary &&
						typeof this.filters.minSalary === "object"
					) {
						minSalaryValue = this.filters.minSalary.min.toString();
						maxSalaryValue = this.filters.minSalary.max.toString();
					}

					payload = {
						...this.filters,
						minSalary: minSalaryValue,
						maxSalary: maxSalaryValue,
						latitude: this.location.latitude,
						longitude: this.location.longitude,
						searchQuery: this.searchQuery,
						locations: this.locations,
						jobID: this.$route.query.jobID ? this.$route.query.jobID : "",
						bookmarked: this.showBookmarked ? true : null,
						page: this.page,
						count: this.count,
					};
				}

				res = await postJobSearch(payload);
				if (res.status === 200) {
					if (isMobile && this.showBookmarked) {
						if (this.page == 0) {
							this.bookmarkedJobs = res.data.data.data;
							this.total = res.data.data.total;
							this.pageEnd = res.data.data.pageEnd;
							this.showLoader = false;
							this.loadingMore = false;
						} else {
							this.bookmarkedJobs = [
								...this.bookmarkedJobs,
								...res.data.data.data,
							];
						}
					} else {
						if (this.page == 0) {
							this.jobs = res.data.data.data;
						} else {
							this.jobs = [...this.jobs, ...res.data.data.data];
						}
					}
					this.total = res.data.data.total;
					this.pageEnd = res.data.data.pageEnd;
					if (this.$route.query.jobID) {
						const listToSearch = this.showBookmarked ? this.bookmarkedJobs : this.jobs;
						const matchedJob = (listToSearch || []).find(j => j.jobID === this.$route.query.jobID);
						if (matchedJob) {
							this.showJobDetails(matchedJob, false);
						} else if (listToSearch && listToSearch.length) {
							this.showJobDetails(listToSearch[0], false);
						}
					}
				} else {
					throw new Error("Failed to fetch jobs");
				}
			} catch (error) {
				console.error(error);
				this.jobs = [];
			} finally {
				this.loader = false;
				this.loadingMore = false;
			}
		},
		async getPreferences(refreshJobs = false) {
			if (this.prefLoader) return;
			this.prefLoader = true;
			console.log("to tooggle");
			try {
				const emailID = this.userinfo.email;
				const res = await getJobPreference(emailID);
				if (res.status == 200) {
					const data = res.data.data;
					if (
						data &&
						data.willingToRelocateTo &&
						data.willingToRelocateTo.length > 0
					) {
						this.prefDefaultLocation = data.willingToRelocateTo[0];
					} else {
						this.prefDefaultLocation = "";
					}
					if (data && data.submitted) {
						this.showPreferences = true;
					} else {
						this.showPreferences = false;
					}
					if (refreshJobs && this.currentTab === "curated") {
						this.page = 0;
						this.jobs = null;
						this.getCuratedJobs();
					}
				}
			} catch {
				console.log("error");
			} finally {
				this.prefLoader = false;
			}
		},
		async fetchProfileAndCompanySkills() {
			try {
				const resp = await getProfileSkills();
				if (resp.status === 200) {
					this.mockInterviewTaken = resp.data.data.data.mock_interview_taken;
				}
			} catch (error) {
				console.error(error);
			}
		},
		async getTopCompanies() {
			try {
				const res = await getTopCompanies(10);

				if (res.status === 200) {
					this.dynamicFilters.customerID = res.data.data.map((company) => {
						return {
							value: company.customerID,
							text: company.customerName + " (" + company.jobCount + " jobs)",
						};
					});
				}
			} catch (error) {
				console.error(error);
			}
		},
		async getLocations() {
			try {
				const res = await getLocations();

				if (res.status === 200) {
					this.dynamicFilters.locationsArray = res.data.data.map((location) => {
						return {
							value: location.location,
							text: location.location + " (" + location.jobCount + " jobs)",
						};
					});
				}
			} catch (error) {
				console.error(error);
			}
		},

		async getSalaryRange() {
			try {
				const res = await getSalaryRange();

				if (res.status === 200) {
					this.dynamicFilters.minSalary = res.data.data.map((salary) => {
						return {
							value: salary,
							text: salary.label + " (" + salary.jobCount + " jobs)",
							jobCount: salary.jobCount,
						};
					});
				}
			} catch (error) {
				console.error(error);
			}
		},
		async getJobTypes() {
			try {
				const res = await getJobTypes();
				if (res.status === 200) {
					this.dynamicFilters.jobType = res.data.data.map((jobType) => {
						return {
							value: jobType._id,
							text: jobType.label + " (" + jobType.jobCount + " jobs)",
							jobCount: jobType.jobCount,
						};
					});
				}
			} catch (error) {
				console.error(error);
			}
		},
		async toggleBookmark(job, isMobile = false) {
			if (!this.hasAccess()) {
				this.openLoginModal();
				return;
			}
			job.bookmarked = !job.bookmarked;
			try {
				const res = await toggleBookmark({
					jobID: job.jobID,
					bookmark: job.bookmarked,
				});
				if (res.status === 200) {
					this.successModal(
						"Success",
						job.bookmarked
							? "Bookmarked Successfully"
							: "Unbookmarked Successfully"
					);
					if (this.showBookmarked) {
						if (isMobile) {
							this.getJobs(true, true);
						} else {
							this.getJobs(false, true);
						}
					}
				}
			} catch (error) {
				job.bookmarked = !job.bookmarked;
				console.error(error);
			}
		},
		async getRelatedJobs(job) {
			try {
				this.relatedJobs = null;
				var payload = {}
				if(!job.isCurated){
					payload = {
					skills: job.skills,
					home: true,
					exclude: {
						jobID: job.jobID,
					},
					}
				}
				else{
					payload = {
						"sortBy":{
							"column":"relevance",
							"order":"-1"
						},
						"dateOfPosting":null,
						"experience":[
							
						],
						"workType":[
							
						],
						"jobType":[
							
						],
						"minSalary":null,
						"maxSalary":null,
						"customerID":[
							
						],
						"industry":[
							
						],
						"qualifications":[
							
						],
						"noticePeriod":null,
						"companyType":null,
						"locationsArray":[
							
						],
						"latitude":null,
						"longitude":null,
						"searchQuery":"",
						"locations":"",
						"jobID":"",
						"bookmarked":null,
						"page":0,
						"jobApplied":false,
						"count":6,
						"home":true
						}

				}
				const res = await postJobSearch(payload);
				if (res.status === 200) {
					this.relatedJobs = res.data.data.data;
				} else {
					throw new Error("Failed to fetch related jobs");
				}
			} catch (error) {
				console.error(error);
				this.relatedJobs = [];
			}
		},
		async getRelatedAssessments() {
			try {
				this.relatedAssessments = null;
				const res = await getPublicAssessments({
					email: this.candidateData.email,
					count: 10,
					home: true,
				});
				if (res.status === 200) {
					this.relatedAssessments = res.data.data.data;
				} else {
					throw new Error("Failed to fetch related jobs");
				}
			} catch (error) {
				console.error(error);
				this.relatedAssessments = [];
			}
		},
		async getCandidatePrimaryProfile() {
			try {
				const res = await getCandidatePrimaryProfile();
				if (res.status === 200) {
					this.candidateData = res.data.data;
				} else {
					this.candidateData = {};
				}
			} catch (error) {
				console.error(error);
			}
		},
		async withdrawApplication(job) {
			this.buttonLoader = true;
			try {
				const res = await withdrawApplication({
					jobID: job.jobID,
					emailID: this.candidateData.email,
				});

				if (res.status === 200) {
					this.successModal("Success", "Withdrawn application successfully");
					this.getJobs();
					this.showWithdrawApplicationModal = false;
					this.showSidePanel = false;
				} else {
					throw new Error("Failed to withdraw application");
				}
			} catch (error) {
				console.error(error);
			} finally {
				this.buttonLoader = false;
			}
		},
		goToInterviewPrep(job) {
			this.$store.commit(
				"candidateVUEX/setSelectedSkillsForInterview",
				job.skills
			);
			const jobData = {
				...job,
				companyName: job.customerName || job.companyName,
			};
			delete jobData.customerName;
			this.$store.commit("candidateVUEX/setSelectedCompany", jobData);
			this.$router.push({
				name: "InterviewSkills",
				query: { bycompany: true, from: "jobsearch" },
			});
		},
		goToMockInterview(job) {
			if (this.mockInterviewTaken >= 2) {
				this.showPaymentComingSoonModal = true;
				return;
			}
			this.$store.commit(
				"candidateVUEX/setSelectedSkillsForInterview",
				job.skills
			);
			const jobData = {
				...job,
				companyName: job.customerName || job.companyName,
			};
			delete jobData.customerName;
			this.$store.commit("candidateVUEX/setSelectedCompany", jobData);
			this.$router.push({
				name: "TakeAiInterview",
				query: { bycompany: true, from: "jobsearch" },
			});
		},
		searchJobs(search, isMobile = true) {
			this.page = 0;
			this.jobs = null;
			this.bookmarkedJobs = null;
			this.bookmarkedSearchQuery = search;
			if (this.currentTab === "curated") {
				this.getCuratedJobs();
			} else {
				this.getJobs(isMobile, true);
			}
		},
		scrollToTop() {
			const element = document.getElementById("jobs");
			if (element) {
				element.scrollTo({
					top: 0,
				});
			}
		},
		onScroll(e) {
			// Get the target element of the scroll event.
			const { target } = e;
			// Check if the user has reached the bottom of the scrollable area.
			if (
				Math.ceil(target.scrollTop) >=
				target.scrollHeight - target.offsetHeight &&
				!this.loadingMore
			) {
				// Check if there is more data to load.
				if (this.checkbetween(this.pageEnd, 0, this.total)) {
					this.loadingMore = true;
					this.page++;
					if (this.currentTab === "curated") {
						this.getCuratedJobs();
					} else {
						this.getJobs();
					}
				}
			}
		},
		checkbetween(x, min, max) {
			// Return `true` if `x` is between `min` and `max`, otherwise `false`.
			return x > min && x < max;
		},
		async getLatLong() {
			if (Capacitor.isNativePlatform()) {
				try {
					const permissionStatus = await Geolocation.checkPermissions();
					if (permissionStatus.location !== "granted") {
						const requestStatus = await Geolocation.requestPermissions();
						if (requestStatus.location !== "granted") {
							console.error("Geolocation permission not granted");
							return;
						}
					}

					const position = await Geolocation.getCurrentPosition({
						enableHighAccuracy: true,
						timeout: 15000,
						maximumAge: 10000,
					});
					this.location = {
						latitude: position.coords.latitude,
						longitude: position.coords.longitude,
					};
				} catch (err) {
					console.error("Error accessing native geolocation:", err);
					if (err.message === "Location services are not enabled") {
						// Using a simple alert or a custom modal if available in the app
						alert("Please enable Location Services (GPS) on your device to see jobs near you.");
					} else {
						console.error("Error accessing native geolocation:", err);
					}
				}
			} else if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition((position) => {
					this.location = {
						latitude: position.coords.latitude,
						longitude: position.coords.longitude,
					};
				});
			} else {
				console.error("Geolocation is not available");
			}
		},
		isShortlisted(job) {
			return job.jobProgress[1]?.state === "Shortlisted" || false;
		},
		showWithdrawApplication(job) {
			if (this.isShortlisted(job)) {
				this.selectedJob = job;
				this.showCannotWithdrawApplicationModal = true;
			} else {
				this.selectedJob = job;
				this.showWithdrawApplicationModal = true;
			}
		},
		searchChanged() {
			if (this.tempSearchQuery !== this.searchQuery && !this.tempSearchQuery) {
				this.applyFilter();
			} else if (this.tempLocations !== this.locations && !this.tempLocations) {
				this.applyFilter();
			}
		},
		getCurrentScreenName() {
			switch (this.currentMobileScreen) {
				case this.MOBILE_SCREENS.MAIN_SCREEN:
					return "Job Search";
				case this.MOBILE_SCREENS.JOB_DETAILS:
					return "Job Details";
				case this.MOBILE_SCREENS.RESUME_SCREEN:
					return "Resume";
				case this.MOBILE_SCREENS.SAVED_JOBS:
					return "Saved Jobs";
				case this.MOBILE_SCREENS.APPLY_JOB:
					return "Apply Job";
				case this.MOBILE_SCREENS.TEST_DETAILS:
					return "Test Details";
				default:
					return "Job Search";
			}
		},
		getBoolean(value) {
			return value === "true" || value === true;
		},
		goToJobSearch() {
			this.searchQuery = "";
			this.tempSearchQuery = "";
			this.location = "";
			this.tempLocations = "";
			this.showSidePanel = false;
			this.$router.go(-1);
		},
		handleJobApplicationSuccess(jobID, isMobile) {
			if (isMobile) this.goBack();
			this.successModal("Success", "Applied Successfully");
			this.showApplyJob = false;
			const appliedJob = this.jobs.find((j) => j.jobID === jobID);
			appliedJob.jobApplied = true;
			this.trackEvent("job_applied", { jobID: appliedJob.jobID });
			this.getJobs();
		},
		goToJobProgress() {
			this.$router.push({
				name: "JobProgress",
			});
		},
		goToAssessment() {
			this.$router.push({
				name: "CandidateAssessmentProgress",
			});
		},
		goToDashboard() {
			this.$router.push({
				name: "CandidateDashboard",
			});
		},
		openGovtJobModal(job) {
			this.selectedJob = job;
			this.govtJobModal = true;
		},
		openApplyJobModal(job) {
			console.log(this.candidateProgress.progress);
			this.trackEvent("job_apply_intent", { jobID: job.jobID });
			if (job.isCurated && job.externalLink) {
				this.openGovtJobModal(job);
				return;
			}
			// if (this.candidateProgress.progress >= 20) {
				this.selectedJob = job;
				this.showApplyJob = true;
				if (!job.isCurated) this.getTrendingJob(job.jobID);
			// } else {
			// 	this.showCompleteProfileModal = true;
			// }
		},
		ceil(num) {
			return Math.ceil(num);
		},
		slice(arr, from, to) {
			return arr.slice(from, to);
		},
		toggleBookmarkedFilter() {
			this.page = 0;
			this.count = 20;
			if (this.$route.query.bookmarked) {
				this.$router.push({
					name: "JobSearch",
				});
			} else {
				this.tempSearchQuery = null;
				this.searchQuery = null;
				this.location = "";
				this.tempLocations = "";
				this.$router.push({
					name: "JobSearch",
					query: {
						bookmarked: true,
					},
				});
			}
		},
		showBookmarkedJobs() {
			this.showBookmarked = true;
			this.currentMobileScreen = this.MOBILE_SCREENS.SAVED_JOBS;
			this.getJobs(true, true);
		},
		toggleFilter() {
			if (!this.showFilter) {
				this.tempFilters = { ...this.filters };
				this.tempFilters[this.SORT_BY_TAB] = this.filters[this.SORT_BY_TAB]
					.column
					? `${this.filters[this.SORT_BY_TAB].column}_${this.filters[this.SORT_BY_TAB].order
					}`
					: null;
			}
			this.showFilter = !this.showFilter;
		},
		toggleSidePanel() {
			this.showSidePanel = !this.showSidePanel;
			if (this.$route.query.from == "resumeclinicModal") {
				const newQuery = { ...this.$route.query };
				delete newQuery.jobID;
				this.$router.replace({ query: newQuery });
			}
		},
		resetFilterWithoutApply() {
			this.tempFilters = { ...TEMP_FILTERS };
			this.filters = { ...this.tempFilters };
			this.filters[this.SORT_BY_TAB] = this.extractSortBy(
				this.tempFilters[this.SORT_BY_TAB]
			);
		},
		applyFilter() {
			this.scrollToTop();
			this.page = 0;
			this.jobs = null;
			this.searchQuery = this.tempSearchQuery;
			this.locations = this.tempLocations;

			let newQuery = { ...this.$route.query };
			let shouldUpdateRoute = false;

			if (!this.searchQuery && newQuery.searchQuery) {
				delete newQuery.searchQuery;
				shouldUpdateRoute = true;
			}
			if (!this.locations && newQuery.locations) {
				delete newQuery.locations;
				shouldUpdateRoute = true;
			}

			if (shouldUpdateRoute) {
				this.$router.replace({ query: newQuery }).catch(() => {});
			}
			if (
				this.tempFilters.minSalary &&
				typeof this.tempFilters.minSalary === "object"
			) {
				this.filters.minSalary = { ...this.tempFilters.minSalary };
			}

			this.filters = { ...this.tempFilters };
			this.filters[this.SORT_BY_TAB] = this.extractSortBy(
				this.tempFilters[this.SORT_BY_TAB]
			);

			this.currentPage = 1;
			if (this.currentTab === "curated") {
				this.getCuratedJobs();
			} else {
				this.getJobs();
			}
			this.showFilter = false;
		},
		resetFilter() {
			this.tempFilters = { ...TEMP_FILTERS };
			if (this.isFiltered) {
				this.applyFilter();
			}
		},
		extractSortBy(sortBy) {
			if (this.tempFilters[this.SORT_BY_TAB])
				return {
					column: sortBy.split("_")[0],
					order: sortBy.split("_")[1],
				};
			else return { column: null, order: null };
		},
		toDropdownOptions(options) {
			if (Array.isArray(options)) {
				return options.map((option) => ({
					value: option,
					text: option,
				}));
			} else {
				return Object.keys(options).map((key) => ({
					value: key,
					text: options[key],
				}));
			}
		},
		toTitleCase(string) {
			if (!string) return "";
			return string
				.split(" ")
				.map((w) => (w && w.length > 0 ? w[0].toUpperCase() + w.slice(1) : w))
				.join(" ");
		},
		arrayToString(arr) {
			arr = arr.filter((a) => a);
			return this.toTitleCase(arr.join(", "));
		},
		showJobDetails(job, isUserClick = true) {
			if (!job) return;
			if (isUserClick) this.trackEvent("job_viewed", { jobID: job.jobID });
			this.selectedJob = job;
			this.jobToMatch = job;
			this.showJobMatch = false;
			this.showSidePanel = false; // Reset to trigger transition
			this.$nextTick(() => {
				this.showSidePanel = true;
			});
			this.jobShimmer = true;

			setTimeout(() => {
				this.jobShimmer = false;
			}, 500);

			this.fetchProfileAndCompanySkills();
			this.getRelatedJobs(job);
			this.getRelatedAssessments();
			if (!job.isCurated) this.getTrendingJob(job.jobID);

			this.currentMobileScreen = this.MOBILE_SCREENS.JOB_DETAILS;
			this.$nextTick(() => {
				const jobDetails =
					document.getElementById("job-details") || this.$refs["job-details"];
				if (jobDetails) {
					if (jobDetails.scrollTo) {
						jobDetails.scrollTo({ top: 0 });
					} else if (jobDetails.$el && jobDetails.$el.scrollTo) {
						jobDetails.$el.scrollTo({ top: 0 });
					}
				}
			});
			trackJobViewed(job)

		},
		isUpcoming(assessment) {
			return (
				new Date(assessment.config.openTestdt).getTime() > new Date().getTime()
			);
		},
		appendQuery(link, query) {
			// let url = new URL(link);
			// url.searchParams.append(query.key, query.value);
			// return url.href;
			const [baseUrl, fragment] = link.split("#");
			//checking for fragmentation in hire3x url

			if (fragment) {
				const [path, queryString] = fragment.split("?");
				const params = new URLSearchParams(queryString || "");
				params.append(query.key, query.value);

				return `${baseUrl}#${path}?${params.toString()}`;
			} else {
				const url = new URL(link);
				url.searchParams.append(query.key, query.value);

				return url.href;
			}
		},
		viewTestDetails(assessment, isMobile) {
			this.selectedAssessment = Object.assign({}, assessment);
			this.selectedAssessment.proctoringType =
				this.getProctoringType(assessment);
			if (this.selectedAssessment.shareLink) {
				if (!Capacitor.isNativePlatform()) {
					this.selectedAssessment.shareLinkWithQuery = this.appendQuery(
						this.selectedAssessment.shareLink,
						{
							key: "from",
							value: "candidate",
						}
					);
				} else {
					this.selectedAssessment.shareLinkWithQuery =
						this.selectedAssessment.shareLink;
				}
			}
			this.showTestDetails = true;
			// this.currentMobileScreen = this.MOBILE_SCREENS.TEST_DETAILS;
			if (isMobile) {
				this.$store.commit(
					"candidateVUEX/addSelectAssess",
					this.selectedAssessment
				);
				this.$router.push({
					name: "mobAssessment",
					query: {
						public: true,
						from: "home",
					},
				});
			}
		},
		getProctoringType(assessment) {
			let proctoringTypes = [];
			if (assessment.config.allowAgent) proctoringTypes.push("agent");
			if (assessment.config.allowExtension) proctoringTypes.push("extension");
			if (assessment.config.enableProctoring) proctoringTypes.push("video");
			return proctoringTypes.join("-");
		},
		async getCuratedJobs() {
			this.loader = true;
			try {
				const payload = {
					keywords: this.searchQuery || "",
					location: this.locations || this.prefDefaultLocation || "Bengaluru",
					page: this.page + 1,
					ResultOnPage: this.count,
					...(this.filters.minSalary && { salary: this.filters.minSalary }),
				};
				const res = await getCuratedJobs(payload);
				if (res.status === 200 && res.data && res.data.data) {
					const curatedJobsList = res.data.data.jobs || [];
					const mappedJobs = curatedJobsList.map((item) => {
						const updatedDate = item.updated ? new Date(item.updated) : null;
						let postedAt = "";
						if (updatedDate) {
							const diffTime = Math.abs(new Date() - updatedDate);
							const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
							postedAt =
								diffDays <= 0 ? "Posted today" : `Posted ${diffDays} days ago`;
						}

						return {
							...item,
							title: item.title || item.caption || "N/A",
							customerName: item.company || item.customerName || "N/A",
							jobID: item.id ? String(item.id) : "N/A",
							location: [item.location || "N/A"],
							jobType: item.type || "",
							experienceRequired: "",
							postedAt: postedAt,
							skills: [],
							skillsToLearn: [], // Required to prevent length error in side panel
							customFields: {
								private_job: false,
								gov_job: false,
								shift: "",
								Board_Organization: "",
								redirectURL_: item.link,
							},
							bookmarked: false,
							jobApplied: item.applied || false,
							addedByRecruiter: false,
							description: item.snippet || item.description, // Required for job details view
							externalLink: item.link,
							isCurated: true,
						};
					});

					if (this.page == 0) {
						this.jobs = mappedJobs;
					} else {
						this.jobs = [...this.jobs, ...mappedJobs];
					}
					this.total = res.data.data.totalCount || mappedJobs.length;
					this.pageEnd = (this.page + 1) * 30;
					if (this.$route.query.jobID) {
						const matchedJob = (this.jobs || []).find(j => j.jobID === this.$route.query.jobID);
						if (matchedJob) {
							this.showJobDetails(matchedJob);
						}
					}
				} else {
					throw new Error("Failed to fetch curated jobs");
				}
			} catch (error) {
				console.error(error);
				this.jobs = [];
			} finally {
				this.loader = false;
				this.loadingMore = false;
			}
		},
		async getTrendingJob(jobID) {
			try {
				let payload = {
					type: "job",
					interactionType: "click",
					referenceID: jobID,
				};
				const response = await getGlobalTrending(payload);
			} catch (error) {
				console.log(error);
			}
		},
	},
	computed: {
		...mapGetters("candidateVUEX", {
			candidateProgress: "getCandProgressResp",
		}),
		isFiltered() {
			for (let key in this.filters) {
				if (key === this.SORT_BY_TAB) {
					if (
						this.filters[key].column &&
						this.filters[key].column !== "relevance"
					)
						return true;
					else continue;
				} else if (Array.isArray(this.filters[key]) && this.filters[key].length)
					return true;
				else if (!Array.isArray(this.filters[key]) && this.filters[key])
					return true;
			}
			return false;
		},
		isFilterChanged() {
			if (
				JSON.stringify(this.filters) !==
				JSON.stringify({
					...this.tempFilters,
					[this.SORT_BY_TAB]: this.extractSortBy(
						this.tempFilters[this.SORT_BY_TAB]
					),
				})
			) {
				return true;
			}
			return false;
		},
		isSearchChanged() {
			return (
				this.tempSearchQuery !== this.searchQuery ||
				this.tempLocations !== this.locations
			);
		},
		showMobileScreen() {
			return Object.keys(this.MOBILE_SCREENS).reduce((acc, cur) => {
				acc[this.MOBILE_SCREENS[cur]] =
					this.currentMobileScreen === this.MOBILE_SCREENS[cur];
				return acc;
			}, {});
		},
	},
};
